import styled from 'styled-components';

const Content = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;

export default Content;
